function Disclaimer() {

  return (
    <div
      id="disclaimer"
      className=" w-[95%] lg:w-4/6 mx-auto min-h-[calc(100vh-3rem-59.23px)] pt-12 lg:pt-24"
    >
      <div className="mb-8">
        <h2 className="font-bold text-2xl lg:text-3xl leading-relaxed">
Disclaimer
        </h2>
        <p className="leading-loose">Diese Webseite ist ausschliesslich für den privaten Gebrauch bestimmt. Es gibt keinen kommerziellen oder geschäftlichen Hintergrund und es werden keine personenbezogenen Daten gespeichert. Die Inhalte dieser Webseite sind ohne Gewähr, wurden jedoch mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte wird jedoch kein Gewähr übernommen.</p>
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-bold leading-relaxed">
Haftungsausschluss
        </h2>
        <p className="leading-loose">Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen. Haftungsansprüche gegen den Autor wegen Schäden materieller oder immaterieller Art, welche aus dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten Informationen, durch Missbrauch der Verbindung oder durch technische Störungen entstanden sind, werden ausgeschlossen. Alle Angebote sind unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</p>
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-bold leading-relaxed">
Haftung für Links
        </h2>
        <p className="leading-loose">Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs Es wird jegliche Verantwortung für solche Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten erfolgen auf eigene Gefahr des Nutzers oder der Nutzerin.</p>
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-bold leading-relaxed">
Datenschutz        </h2>
        <p className="leading-loose">Für die Sicherheit der Datenübertragung im Internet können wir keine Gewähr übernehmen, insbesondere besteht bei der Übertragung von Daten per E-Mail die Gefahr des Zugriffs durch Dritte. Einer Nutzung der im Impressum veröffentlichten Kontaktdaten durch Dritte zu Werbezwecken wird hiermit ausdrücklich widersprochen. Der Betreiber behält sich für den Fall unverlangt zugesandter Werbe- oder Informationsmaterialien ausdrücklich rechtliche Schritte vor. Sollten einzelne Regelungen oder Formulierungen dieses Haftungsausschlusses unwirksam sein oder werden, bleiben die übrigen Regelungen in ihrem Inhalt und ihrer Gültigkeit hiervon unberührt.</p>
      </div>

      <div className="mb-8">
        <h2 className="text-xl font-bold leading-relaxed">
Urheberrechte        </h2>
        <p className="leading-loose">Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf der Website gehören ausschliesslich dem Betreiber der Webseite oder den speziell genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.</p>
      </div>
      <div className="mb-8">
        <h2 className="text-xl font-bold leading-relaxed">
SSL/TLS-Verschlüsselung
        </h2>
        <p className="leading-loose">Diese Website verwendet aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie z.B. Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- oder TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten gelesen werden.</p>
      </div>

      <div className="mb-8">
        <h2 className="font-bold text-2xl lg:text-3xl leading-relaxed">
          Kontakt
        </h2>
        <p className="leading-loose">Fabian Rapold</p>
        <a href="mailto:contact@fabianrapold.com" className="leading-loose">contact@fabianrapold.com</a>
        <p className="leading-loose"></p>
        <p className="leading-loose"></p>
        <p className="leading-loose"></p>
      </div>
    </div>
  );
}

export default Disclaimer;
